module.exports = __webpack_public_path__ + "img/phone.47591954.svg";